import { APIFactory } from '../../ui-toolkit/rest/APIFactory';
import { axiosErrorHandler } from '../../ui-toolkit/rest/axiosErrorHandler';
import { baseUrlService } from '../../ui-toolkit/rest/BaseUrlService';
import {
  convertTaxCertificationListResponseToTaxCertificationListData,
  ITaxCertificationListData,
  ITaxCertificationListResponse,
} from 'ui-toolkit/taxCertifications/ITaxCertification';

export const getTaxCertificationsAsync = async (orderId: string): Promise<ITaxCertificationListData> => {
  return APIFactory(baseUrlService.ApiLocation)
    .get<ITaxCertificationListResponse>(`timber/api/internal/orders/${orderId}/tax_certifications`)
    .then((response) => convertTaxCertificationListResponseToTaxCertificationListData(response.data))
    .catch(axiosErrorHandler);
};
